/**
 * Format a byte count into a human-readable string (B, KB, MB, GB).
 * Shared by it-upload and it-upload-drag-drop.
 */
function formatSize(bytes) {
    if (bytes === 0)
        return '0 B';
    const k = 1024;
    const sizes = ['B', 'KB', 'MB', 'GB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return `${parseFloat((bytes / k ** i).toFixed(1))} ${sizes[i]}`;
}

export { formatSize as f };
//# sourceMappingURL=utils-xlxkOHqp.js.map
